import type { NavigationSection } from '../types/navigation';

export const NAVIGATION_SECTIONS: NavigationSection[] = [
  {
    id: 'hero',
    label: 'Home',
    href: '#hero'
  },
  {
    id: 'about',
    label: 'About',
    href: '#about'
  },
  {
    id: 'practice-areas',
    label: 'Practice Areas',
    href: '#practice-areas'
  },
  {
    id: 'other-services',
    label: 'Other Services',
    href: '#other-services'
  },
  {
    id: 'approach',
    label: 'Our Approach',
    href: '#approach'
  },
  {
    id: 'leadership',
    label: 'Leadership',
    href: '#leadership'
  },
  {
    id: 'insights',
    label: 'Insights',
    href: '#insights'
  },
  {
    id: 'contact',
    label: 'Contact',
    href: '#contact'
  }
];